// import './plugins/axios';
// import './registerServiceWorker';
import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store/index';
import 'bootstrap';
import Vuelidate from 'vuelidate';
import { IframeParentCommnuicationService } from '@/services/IframeParentCommnuicationService';
import { Route } from 'vue-router';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';

Vue.use(Vuelidate);
Vue.config.productionTip = false;

// Todo: Temp expose the Vue app on the global namespace as App
// Remove before we go live
class InitializationWatcher {
    public configLoaded: boolean = false;
    public tagsLoaded: boolean = false;
    public propertiesLoaded: boolean = false;
}

declare global {
    interface Window {
        App: Vue;
        InitializationWatcher: InitializationWatcher;
    }
}

const iframeParentCommnuicationService = new IframeParentCommnuicationService();
const data = {
    action: 'eIn_alert_message',
    value: {
        headline: '',
        message: '',
        type: 'danger',
        isDismissible: true
    },
};

router.beforeEach((to: Route, from: Route, next: () => void) => {
    // use router before each to send the event messsage to parent
    // to make sure change the fullscreen before the component load
    if (window.handshake) {
        if (to.name === 'audience-create' || to.name === 'audience-clone' || to.name === 'audience-edit') {
            const data = { action: 'eIn_fullscreen', value: to.path, };
            iframeParentCommnuicationService.SendMessageToParent(data);
        } else {
            const data = { action: 'eIn_exit_fullscreen', value: to.path, };
            iframeParentCommnuicationService.SendMessageToParent(data);
        }
    }
    next();
});

const axiosConfig: AxiosRequestConfig = {
    // if interceptError is set to true, request error will be handled in the interceptor
    interceptError: true

    // baseURL: process.env.baseURL || process.env.apiUrl || "https://localhost:44383/",
    // timeout: 60000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};
const axiosInstance = axios.create(axiosConfig);
// Add a request interceptor
axiosInstance.interceptors.request.use(
    (cfg: AxiosRequestConfig) => {
        if (!cfg.hasOwnProperty('interceptError')) {
            cfg.interceptError = true;
        }
        return cfg;
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    },
);
// Add a response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        return Promise.resolve(response);
    },
    (error) => {
        console.log('error.config; ', error.config);
        if (error.config.hasOwnProperty('interceptError') && error.config.interceptError === true) {
            if (error.response && error.response.status) {
                switch (error.response.status) {
                    case 401:
                        data.value.message = 'Authentication failed !';
                        iframeParentCommnuicationService.SendMessageToParent(data);
                        break;
                    case 403:
                        data.value.message = 'You don\'t have the permission !';
                        iframeParentCommnuicationService.SendMessageToParent(data);
                        break;
                    case 404:
                        data.value.message = 'Page not found !';
                        iframeParentCommnuicationService.SendMessageToParent(data);
                        break;
                    // case 500:
                    // case 501:
                    // case 502:
                    // case 503:
                    // case 504:
                    //    data.action = 'eIn_error';
                    //    data.value.message = 'Server Error !';
                    //    iframeParentCommnuicationService.SendMessageToParent(data);
                    //    break;
                    default:
                        // data.value.message = 'Unknown Response Error : ' + error.response.status;
                        // iframeParentCommnuicationService.SendMessageToParent(data);
                        break;
                }
                return Promise.reject(error.response);
            }

        } else {
            return Promise.reject(error);
        }
    }
);

Vue.prototype.$axios = axiosInstance;

window.App = new Vue({
    router,
    store,
    render: (h) => h(App),
});

const urlParams = new URLSearchParams(window.location.search);
const eInsightUserEmailPar = urlParams.get('userEmail');
window.eInsightUserEmail = eInsightUserEmailPar ? eInsightUserEmailPar.toString() : '';
// window.eInsightUserEmail = 'aGRhdmVAY2VuZHluLmNvbQ%3D%3D';
console.log('eInsightUserEmail: ', window.eInsightUserEmail);

const eInsightUserRegionPar = urlParams.get('region');
window.eInsightUserRegion = eInsightUserRegionPar ? eInsightUserRegionPar.toString() : '';
const eInsightUserLanguagePar = urlParams.get('language');
window.eInsightUserLanguage = eInsightUserLanguagePar ? eInsightUserLanguagePar.toString() : '';
console.log('eInsightUserRegion: ', window.eInsightUserRegion);
console.log('eInsightUserLanguage: ', window.eInsightUserLanguage);

window.InitializationWatcher = new InitializationWatcher();
window.App.$mount('#app');
